import React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { DataGrid } from "@mui/x-data-grid";
import { durationList, sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  getScenarioChartData,
  getScenarios,
  setState,
  getAnalyzeTradeProducts,
  getAnalyzeTradeForm,
  getAnalyzeTradeStrength,
  getProductQuota,
  exportFile_TradeDetails,
} from "../analyzeSlice";
import _ from "lodash";

import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import CollapseSection from "../../../components/ui/CollapseSection";

const selectWidth = sizes.w230;
const selectHeight = sizes.h35;

export default function TradeDetails() {
  const [validate, setValidate] = useState({
    countryValidated: false,
    productValidated: false,
    formValidated: false,
    strengthValidated: false,
    durationValidated: false,
  });
  
  const [countryTD, setCountryTD] = useState("");

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const [rows, setRows] = useState([]);
  const [exportRows, setExportRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    scenarios,
    selectedScenarioName,
    selectedProductName,
    tradeProducts,
    tradeForms,
    tradeStrength,
    selectedTradeProduct,
    selectedTradeForms,
    selectedTradeStrengths,
    selectedAnalysisTypeID,
    duration,
    productQuota,
    clearAnalyzeTradeDetails,
  } = state;

  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  const [formValue, setFormValue] = useState([]);
  const [strengthValue, setStrengthValue] = useState([]);

  useEffect(() => {
    if (selectedCountryID !== "") {
      //getScenariosForCountry();
    }
  }, [selectedCountryID]);

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedTradeProduct", ""));
    dispatch(setState("duration", null));
    dispatch(setState("clearAnalyzeTradeDetails", false));

    dispatch(setState("tradeProducts", []));
    
  }, []);

  const clearValuesForCountry = () => {
    dispatch(setState("selectedTradeProduct", ""));
    setFormValue([]);
    setStrengthValue([]);
  };

  const clearValuesForProduct = () => {
    setFormValue([]);
    setStrengthValue([]);
  };

  function setCountry(event) {
    const name = event.target.value;
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;
    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));

    setCountryTD(name);

    clearValuesForCountry();

    dispatch(setState("clearAnalyzeTradeDetails", false));
  }

  // useEffect(() => {
  //   if (globalSelectedCountryID !== null) {
  //     dispatch(setState("selectedCountryID", globalSelectedCountryID));
  //   }
  // }, [globalSelectedCountryID]);

  // useEffect(() => {
  //   if (globalSelectedCountryName !== null) {
  //     dispatch(setState("selectedCountry", globalSelectedCountryName));
  //   }
  // }, [globalSelectedCountryName]);

  // function getScenariosForCountry() {
  // 	const countryID = selectedCountryID;
  // 	const activeScenario = false;
  // 	const analyisID = selectedAnalysisTypeID;
  // 	const obj = {
  // 		countryID,
  // 		activeScenario,
  // 		analyisID,
  // 	};
  // 	dispatch(getScenarios(obj));
  // }

  function setProduct(event) {
    const name = event.target.value;
    if (name) {
      setValidate({
        ...validate,
        productValidated: true,
      });
    }
    dispatch(setState("selectedTradeProduct", name));
    //dispatch(setState("selectedCountryID", countryID));
    clearValuesForProduct();
  }

  function getProductsForSelectedCountry() {
    const countryID = selectedCountryID;
    const activeScenario = false;
    const analyisID = selectedAnalysisTypeID;
    const obj = {
      countryID,
      //activeScenario,
      //analyisID,
    };
    dispatch(getAnalyzeTradeProducts(obj));
  }

  function getForms() {
    const countryID = selectedCountryID;
    const productName = selectedTradeProduct;
    const obj = {
      countryID,
      productName,
    };
    dispatch(getAnalyzeTradeForm(obj));
  }

  function getStrengths() {
    const countryID = selectedCountryID;
    const productName = selectedTradeProduct;
    const formsType = selectedTradeForms;
    const obj = {
      countryID,
      productName,
      formsType,
    };
    dispatch(getAnalyzeTradeStrength(obj));
  }

  function handleTradeForms(values) {
    console.log(values);
    const formNames = values;
    dispatch(setState("selectedTradeForms", formNames));
    setFormValue(values);
    if (values.length > 0) {
      setValidate({
        ...validate,
        formValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        formValidated: false,
      });
    }
  }

  function handleTradeStrengths(values) {
    const strengthNames = values;
    dispatch(setState("selectedTradeStrengths", strengthNames));
    setStrengthValue(values);
    if (values.length > 0) {
      setValidate({
        ...validate,
        strengthValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        strengthValidated: false,
      });
    }
  }

  function setDuration(event) {
    const d = event.target.value;
    if (d) {
      setValidate({
        ...validate,
        durationValidated: true,
      });
    }
    dispatch(setState("duration", d));
  }

  // function setScenario(event) {
  // 	const name = event.target.value;
  // 	const id = scenarios.find(
  // 		(scenario) => scenario.scenarioName === name
  // 	).scenarioID;
  // 	if(name){
  // 		setValidate({
  // 			...validate, scenarioValidated:true
  // 		})
  // 	}
  // 	dispatch(setState("selectedScenarioName", name));
  // 	dispatch(setState("selectedScenarioID", id));
  // }

  useEffect(() => {
    if (countryTD !== "") {
      getProductsForSelectedCountry();
    }
  }, [countryTD]);

  useEffect(() => {
    if (selectedTradeProduct !== "") {
      getForms();
    }
  }, [selectedTradeProduct]);

  useEffect(() => {
    if (selectedTradeForms?.length > 0) {
      getStrengths();
    }
  }, [selectedTradeForms]);

  // useEffect(() => {
  // 	//Check if any of the dropdown are false and then set alertDisplay to false
  // 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

  // 	if (isAnyKeyValueFalse(validate)) {
  // 		setAlert({ ...Alert, alertDisplay: false });
  // 	}
  // }, [validate])

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [2000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };
  useEffect(() => {
    if (
      productQuota !== null &&
      productQuota !== undefined &&
      !_.isEmpty(productQuota)
    ) {
      // Extract column definitions from keys
      const columns = Object?.keys(productQuota?.analyzeTradeDetails[0])?.map(
        (key) => ({
          field: key,
          headerName: (
            key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")
          ).replace(/([A-Z])/g, " $1"),
          flex: 1,
          minWidth: 100,
        })
      );

      // Map the array of data to rows
      const rows = productQuota?.analyzeTradeDetails.map((item, index) => ({
        id: index,
        ...item,
      }));

      const exportData = productQuota?.analyzeTradeDetails.map(
        (item, index) => ({
          ...item,
        })
      );

      setExportRows(exportData);

      setRows(rows);
      setColumns(columns);
    }
  }, [productQuota]);

  function exportDataAsFile(isPdf) {
    const obj = {
      isPdf,
      Type: "TradeDetails",
      AnalyzeTitle: "Analyze: Trade Details",
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      Duration: duration,
      listAnalyseData: exportRows,
    };
    dispatch(exportFile_TradeDetails(obj));
  }

  function handleDisplay() {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (selectedTradeProduct === null || selectedTradeProduct === "") {
      displayAlert("Product Name");
      return;
    }
    if (formValue.length === 0) {
      displayAlert("Form");
      return;
    }
    if (strengthValue.length === 0) {
      displayAlert("Strength");
      return;
    }
    if (duration === null || duration === "") {
      displayAlert("Duration");
      return;
    }

    const obj = {
      productName: selectedTradeProduct,
      countryID: selectedCountryID,
      formsType: selectedTradeForms,
      duration: duration,
      strength: selectedTradeStrengths,
    };

    dispatch(setState("clearAnalyzeTradeDetails", true));

    dispatch(getProductQuota(obj));
  }

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Grid
          container
          // columns={12}
          spacing={2}
        >
          <Grid
            item
          // sm={6} md={4} lg={2}
          >
            <FormControl sx={{ minWidth: "200px" }}>
              <InputLabel>Country</InputLabel>
              <Select
                value={countryTD}
                label="Country"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                size="small"
                onChange={setCountry}
              >
                {countries?.map((country, index) => {
                  return (
                    <MenuItem key={index} value={country.countryName}>
                      {country.countryName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            // sm={6} md={4} lg={2.9}
            sx={{ minWidth: "250px" }}
          >
            <FormControl>
              <InputLabel>Product Name</InputLabel>
              <Select
                value={selectedTradeProduct}
                label="Product Name"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                size="small"
                onChange={setProduct}
              >
                {tradeProducts?.map((product, index) => {
                  return (
                    <MenuItem key={index} value={product}>
                      {product}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            sx={{ minWidth: "300px" }}
          // sm={6} md={4} lg={2}
          >
            <Autocomplete
              multiple
              id="tradeForms"
              size="small"
              options={tradeForms}
              getOptionLabel={(option) => option}
              value={formValue}
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                //mt:1
              }}
              onChange={(event, values) => handleTradeForms(values)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //variant="standard"
                  size="small"
                  label="Form"
                  placeholder=""
                />
              )}
            />
          </Grid>

          <Grid
            item
            sx={{ minWidth: "350px" }}
          // sm={6} md={4} lg={2}
          >
            <Autocomplete
              multiple
              id="tradeStrengths"
              size="small"
              options={tradeStrength}
              getOptionLabel={(option) => option}
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                //mt:1
              }}
              value={strengthValue}
              onChange={(event, values) => handleTradeStrengths(values)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //variant="standard"
                  size="small"
                  label="Strength"
                  placeholder=""
                />
              )}
            />
          </Grid>

          <Grid item sm={6} md={2} lg={1.5}>
            <FormControl>
              <InputLabel>Duration</InputLabel>
              <Select
                value={duration}
                label="Duration"
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={setDuration}
              >
                {durationList.map((duration, index) => {
                  return (
                    <MenuItem key={index} value={duration.value}>
                      {duration.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={6} md={4} lg={1}>
            <Button
              startIcon={<DvrIcon />}
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
                //mt: 1.5
              }}
              onClick={handleDisplay}
            >
              Display
            </Button>
          </Grid>
        </Grid>
        {alert.alertDisplay && (
          <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
        )}
      </Box>
      {rows.length > 0 && clearAnalyzeTradeDetails && (
        <CollapseSection title="  Analyze Trade Details">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              justifyContent: "flex-end",
            }}
          >
            <IconButton onClick={(e) => exportDataAsFile(false)}>
              <GridOnIcon sx={{ color: "green.main" }} />
            </IconButton>
            <IconButton onClick={(e) => exportDataAsFile(true)}>
              <PictureAsPdfIcon sx={{ color: "red.main" }} />
            </IconButton>
          </Box>

          <Box sx={{ mt: 3 }}>
            <DataGrid
              disableColumnMenu
              rows={rows || []}
              columns={columns}
              getRowId={(row) => row?.id}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                  },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
              sx={{
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  fontWeight: "bold !important",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal",
                  fontWeight: "bold",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeader": {
                  // Forced to use !important since overriding inline styles
                  height: "unset !important",
                  backgroundColor: "rgba(235, 246, 250)",
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use !important since overriding inline styles
                  maxHeight: "168px !important",
                },
              }}
            />
          </Box>
        </CollapseSection>
      )}
    </>
  );
}
